// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Icons-cls1___bbd5fef178e7423e7d0{/*!*/}.Icons-cls2___6d1a3099e1a1fc099a1{display:flex}.Icons-cls2___6d1a3099e1a1fc099a1 svg{fill:currentColor;stroke:currentColor;width:inherit;height:inherit;stroke-width:.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Icons-cls1___bbd5fef178e7423e7d0",
	"cls2": "Icons-cls2___6d1a3099e1a1fc099a1 Icons-cls1___bbd5fef178e7423e7d0"
};
export default ___CSS_LOADER_EXPORT___;
